
document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('.sticky-header');
  const banner = document.querySelector('.shopify-section-template--16779133288550__image_banner'); 

  // Make sure the banner element exists
  if (!header || !banner) return; 

  const bannerHeight = banner.offsetHeight; 

  window.addEventListener('scroll', function () {
    
    let scrollY = window.scrollY;
    
    
    if (scrollY > bannerHeight) {
      // Gradually increase opacity as you scroll down
      let opacity = Math.min(1, (scrollY - bannerHeight) / 200); // Adjust '200' to control speed of fading
      header.style.backgroundColor = `rgba(255, 255, 255, ${opacity})`;
    } else {
      // Keep it fully transparent as long as it's over the banner
      header.style.backgroundColor = 'rgba(255, 255, 255, 0)';
    }
  });
});
// Global hover listener for Dawn navigation mega menus and dropdowns
document.addEventListener('DOMContentLoaded', () => {
  if (window.matchMedia('(min-width: 990px)').matches) {
    const detailsElements = document.querySelectorAll('header-menu details, .header__inline-menu details');
    
    detailsElements.forEach(details => {
      let hoverTimeout;
      const summary = details.querySelector('summary');
      
      // Jab hover menu pe aaye 
      details.addEventListener('mouseenter', () => {
        if (!window.matchMedia('(min-width: 990px)').matches) return;
        clearTimeout(hoverTimeout);
        if (!details.hasAttribute('open')) {
          details.setAttribute('open', '');
          if (summary) summary.setAttribute('aria-expanded', 'true');
        }
      });

      // Jab hover hategi menu se 
      details.addEventListener('mouseleave', () => {
        if (!window.matchMedia('(min-width: 990px)').matches) return;
        hoverTimeout = setTimeout(() => {
          details.removeAttribute('open');
          if (summary) summary.setAttribute('aria-expanded', 'false');
        }, 150); // thoda sa delay taaki cursor skip na kare
      });

      // Puraane click settings overlap hone se rokne ke liye
      if (summary) {
        summary.addEventListener('click', (e) => {
          if (window.matchMedia('(min-width: 990px)').matches) {
            e.preventDefault(); 
          }
        });
      }
    });
  }
});

